import { Service } from '@/domain/SaleOrder/Service';
import { Shipment } from '@/domain/SaleOrder/Shipment';
import { type SaleOrderData } from '@/infra/services/sale-order/model';

const shipmentsAdapter = (data: SaleOrderData) => {
  return data.shipments.map(
    (shipment) =>
      new Shipment({
        ...shipment,
        marketplaceOrderId: shipment.marketplaceOrder,
      })
  );
};

const servicesAdapter = (data: SaleOrderData) => {
  return data.services
    ? {
        items: data.services.items.map((service) => new Service(service)),
        installationAddress: data.services.installationAddress,
      }
    : null;
};

export const baseSaleOrderAdapter = (data: SaleOrderData) => {
  const shipments = shipmentsAdapter(data);
  const services = servicesAdapter(data);

  return {
    id: data.id,
    createdAt: data.createdAt,
    status: data.status,
    shipments,
    payments: data.payments,
    values: data.values,
    phone: data.phone,
    services,
    recipient: data.recipient,
  };
};
